import { hasAnyAccess } from "helper/access-permission"
import { useEffect, useState } from "react";
import CrudPage from "pages/layout/crud-page";
import { UseAuth } from "hook/auth-hook";
import { RestUseCase } from "service/api/rest/rest-usecase";
import { EntityField } from "../../../@types/entity/field/crud/field-crud-entity";
import ErrorNotAuthorizedPage from "pages/layout/error/error-not-authorized-page";
import { HeaderNavegationList } from "helper/adapter/headerNavigation/header-navegation-adapter";
import { SelectOptionInterface } from "../../../@types/entity/interface/select-option-interface";
import { getEnv } from "helper/window-helper"

export const CurveScoreFactory: React.FC = () => {
    /** ENDPOINT */
    const ENDPOINT_CRUD = getEnv("REACT_APP_END_POINT_SCORE_CURVE")!

    /** TITULO DA PAGINA */
    const titlePage = "Cadastrar Pontuação por Curva";

    /** CAMPOS PARA MODAL E TABELA */
    const entityFields: EntityField[] = [
        {
            name: "curva",
            labelField: "Curva:",
            labelTable: "Curva",
            typeField: "radio",
            valueField: null,
            listValueField: [
                { label: "A", value: "A" },
                { label: "B", value: "B" },
                { label: "C", value: "C" },
                { label: "D", value: "D" },
                { label: "N", value: "N" },
            ],
            sizeField: 0,
            required: false,
            align: "center",
            tableField: { column: "Curva", columnVisible: true },
        },
        {
            name: "inicio",
            labelField: "Pontuação Inicial:",
            labelTable: "Pontuação Inicial",
            typeField: "number",
            valueField: "",
            sizeField: 0,
            required: false,
            align: "right",
            tableField: { column: "Pontuação Inicial", columnVisible: true },
        },
        {
            name: "fim",
            labelField: "Pontuação Final:",
            labelTable: "Pontuação Final",
            typeField: "number",
            valueField: "",
            sizeField: 0,
            required: false,
            align: "right",
            tableField: { column: "Pontuação Final", columnVisible: true },
        },
    ];
    const [entity, updateEntity] = useState(entityFields);

    /** TABELA */
    const [tableHeader, updateTableHeader] = useState<any[]>([]);
    const [tableBody, updateTableBody] = useState([]);

    /** VERIFICA PERMISSAO DE ACESSO */
    const { loggedUserData } = UseAuth();
    const [showScreen, updateShowScreen] = useState<boolean>(false);
    useEffect(() => {
        const roleScreen = HeaderNavegationList.filter(
            (header) => header.navTitle === "Configurações"
        )[0].navItem.filter(
            (item) => item.title === "Cadastrar Pontuação Curva"
        )[0].access;

        if (hasAnyAccess(loggedUserData?.access, roleScreen)) {
            updateShowScreen(true)
        }
    }, [loggedUserData]);

    const [idCompany, updateIdCompany] = useState<number>();
    const [modelCompany, updateModelCompany] =
        useState<SelectOptionInterface>();
    function handleSelectProvider(filial: { value: number; label: string }) {
        updateModelCompany(filial);
        updateIdCompany(filial.value);
        if (filial.value) {
            getAllV2(filial.value);
        }
    }

    async function getAllV2(company: number) {
        const response = await new RestUseCase(`${ENDPOINT_CRUD}/${company}`)
            .Get()
            .finally();

        updateTableHeader(
            entityFields.map((value) => {
                return {
                    name: value.name,
                    labelTable: value.labelTable,
                    align: value.align,
                    columnVisible: value.tableField.columnVisible,
                };
            })
        );
        updateTableBody(response.body);
    }

    return (
        <>
            {showScreen ? (
                <CrudPage
                    handleSelectProvider={handleSelectProvider}
                    readonly={false}
                    filterByCompany={true}
                    modelCompany={modelCompany}
                    entityFields={entity}
                    updateEntity={updateEntity}
                    titlePage={titlePage}
                    getAll={async function () {
                        const response = await new RestUseCase(
                            `${ENDPOINT_CRUD}/${idCompany}`
                        )
                            .Get()
                            .finally();

                        updateTableHeader(
                            entityFields.map((value) => {
                                return {
                                    name: value.name,
                                    labelTable: value.labelTable,
                                    align: value.align,
                                    columnVisible:
                                        value.tableField.columnVisible,
                                };
                            })
                        );
                        updateTableBody(response.body);
                    }}
                    getById={async function (id: number) {
                        const response = await new RestUseCase(
                            `${ENDPOINT_CRUD}/${idCompany}/${id}`
                        )
                            .GetById()
                            .finally();

                        updateEntity(
                            entityFields.map((value) => {
                                value.valueField = response.body[value.name];
                                return value;
                            })
                        );
                    }}
                    post={async function (model: any) {
                        const id = model["curva"];
                        delete model["curva"];
                        await new RestUseCase(`${ENDPOINT_CRUD}/${idCompany}/${id}`)
                            .Post({ data: model })
                            .finally();
                    }}
                    put={async function (id: number, model: any) {
                        const response = await new RestUseCase(
                            `${ENDPOINT_CRUD}/${idCompany}/${id}`
                        )
                            .Put({ data: model })
                            .finally();

                        updateEntity(
                            entityFields.map((value) => {
                                value.valueField = response.body[value.name];
                                return value;
                            })
                        );
                    }}
                    del={async function (id: number) {
                        await new RestUseCase(
                            `${ENDPOINT_CRUD}/${idCompany}/${id}`
                        )
                            .Delete()
                            .finally();
                    }}

                    tableHeader={tableHeader}
                    tableBody={tableBody}
                    valueId={"curva"}
                />
            ) : (
                <ErrorNotAuthorizedPage />
            )}
        </>
    );
};
